import type { CampaignDTO, CampaignStorage, NotApplicableCampaignStorage } from 'src/common/interfaces/campaigns';
import type { CampaignType } from 'src/features/admin/campaigns/campaigns.types';

export const CAMPAIGN_STORAGE_KEY = 'thm_campaigns';
export const CAMPAIGN_NOT_APPLICABLE_STORAGE_KEY = 'thm_not_applicable_campaign';

const defaultStorageData: CampaignStorage = {
  activeCampaign: null,
  seenCampaigns: [],
};

const defaultNotApplicableCampaignStorageData: NotApplicableCampaignStorage = {
  campaignFriendlyName: '',
  campaignName: '' as string,
  campaignType: '' as CampaignType,
};

export const readStoredCampaigns = (): CampaignStorage => {
  try {
    const stored = localStorage.getItem(CAMPAIGN_STORAGE_KEY) || '';
    return (JSON.parse(stored) as CampaignStorage) || defaultStorageData;
  } catch {
    return defaultStorageData;
  }
};

export const readStoredNotApplicableCampaign = (): NotApplicableCampaignStorage => {
  try {
    const stored = localStorage.getItem(CAMPAIGN_NOT_APPLICABLE_STORAGE_KEY) || '';
    return (JSON.parse(stored) as NotApplicableCampaignStorage) || defaultNotApplicableCampaignStorageData;
  } catch {
    return defaultNotApplicableCampaignStorageData;
  }
};

export const storeCampaigns = (campaigns: CampaignStorage) => {
  localStorage.setItem(CAMPAIGN_STORAGE_KEY, JSON.stringify(campaigns));
};

export const storeNotApplicableCampaign = (campaign: NotApplicableCampaignStorage) => {
  localStorage.setItem(CAMPAIGN_NOT_APPLICABLE_STORAGE_KEY, JSON.stringify(campaign));
};

export const removeNotApplicableCampaign = () => {
  localStorage.removeItem(CAMPAIGN_NOT_APPLICABLE_STORAGE_KEY);
};

export const setActiveCampaign = (campaign?: CampaignDTO) => {
  storeCampaigns({
    ...readStoredCampaigns(),
    activeCampaign: campaign
      ? {
          name: campaign.name,
          type: campaign.type,
          sessionExpiration: Date.now() + (campaign.sessionExpiration ?? 0),
        }
      : null,
  });
};

export const setNotApplicableCampaign = (campaign?: CampaignDTO) => {
  if (campaign)
    storeNotApplicableCampaign({
      campaignName: campaign.name,
      campaignType: campaign.type,
      campaignFriendlyName: campaign.userFriendlyName ?? '',
    });
};
